// @vue/component
export default {
  name: 'ShTextWrapper',

  props: {
    text: {
      type: String,
      default: 'Some long text',
    },
    width: {
      type: String,
      default: '120px',
    },
  },
};
